<ngx-spinner bdColor="rgba(51,51,51,0.55)"
             size="medium"
             color="#fff"
             type="line-spin-clockwise-fade"
             [fullScreen]="false">
    <p class="loading">{{ 'general.loading' | translate }}...</p>
</ngx-spinner>
<div class="col-12 col-12-nav-padding">

    <div class="col-12 p-0">
        <h2 class="page-title" tabindex="0">{{ 'manage_documents.title' | translate }}</h2>
    </div>
    
    <xng-breadcrumb separator=" > ">
        <ng-container *xngBreadcrumbItem="let breadcrumb">
            <span *ngIf="breadcrumb">
                {{ 'breadcrumb.' + breadcrumb | translate }}
                <span *ngIf="isBreadcrumbFinal(breadcrumb)">
                    - {{ user.firstName }} {{ user.lastName }}
                </span>
            </span>
        </ng-container>
    </xng-breadcrumb>
    <div class="card upload-doc-card mb-2" *ngxPermissionsExcept="['Activate', 'Expired']">
        <div class="w-100">
            <div class="col-xs-12 mt-3 w-100">
                <div class="main-card-text">
                    <h4>{{ 'manage_documents.upload_title' | translate }}</h4>
                </div>
                <hr class="ml-3 mr-3">
                <div class="main-card-text">
                    {{ 'manage_documents.max_upload_size' | translate }}
                </div>
            </div>
        </div>
        <div class="pl-2 pr-2">
            <div class="row mt-2">
                <div class="col-12 text-center">
                    <div class="custom-file text-center mt-2 mw">
                        <input type="file" class="custom-file-input" id="customFileLang" [lang]="lang"
                               (change)="handleDocumentUpload($event.target.files)" title="{{'general.select' | translate}}">
                        <div class="custom-file-label custom-label" for="customFileLang" id="fileLabel"></div>
                    </div>
                </div>
            </div>
            <div class="row text-center mt-2">
                <div id="doc-err" class="col-12 error"></div>
            </div>
            <div class="row mt-2 mb-2">
                <div class="col-12 text-center">
                    <button type="button" title="{{'profile.upload' | translate}}" class="btn btn-green btn-dis-green btn-h-green float-center w-100 mw" [disabled]="!document"
                            (click)="saveDocument()">
                        {{ 'profile.upload' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="container card-container">
        <div class="row myrow pb-1">
            <div class="col-sm-12 col-md-6 col-lg-4 pb-2" *ngFor="let document of documents">
                <div class="card">
                    <div ngbDropdown class="d-inline-block">
                        <i class="fa fa-ellipsis-v ellipsis" id="actions" ngbDropdownToggle></i>
                        <div ngbDropdownMenu aria-labelledby="actions">
                            <button class="dropdown-item" title="{{ 'general.download' | translate }}" ngbDropdownItem (click)="downloadDocument(document.name,document.path)"><i class="fa fa-download pr-1"></i>{{ 'general.download' | translate }}</button>
                            <button class="dropdown-item" title="{{ 'general.preview' | translate }}" ngbDropdownItem (click)="viewDocumentModal(document)"><i class="fa fa-eye pr-1"></i>{{ 'general.preview' | translate }}</button>
                            <button class="dropdown-item" title="{{ 'general.remove' | translate }}" ngbDropdownItem (click)="deleteDocument(document)" *ngxPermissionsExcept="['Activate', 'Expired']"><i class="fa fa-trash pr-1"></i>{{ 'general.remove' | translate }}</button>
                        </div>
                    </div>
                    <div class="card-block pt-2 pb-2">
                        <div class="row full-width-row m-0">
                            <div class="col-sm-2 col-md-3 col-lg-2 my-auto">
                                <i *ngIf="document.name.slice(-3) == 'pdf'" class="fa fa-file-pdf-o fa-3x"></i>
                                <i *ngIf="document.name.slice(-3) != 'pdf'" class="fa fa-file-image-o fa-3x"></i>
                            </div>
                            <div class="col-sm-10 col-md-9 col-lg-10">
                                <p class="card-title"><strong>{{ document.name }}</strong></p>
                                <p class="card-text"><small class="text-muted">{{ 'manage_documents.updated_on' | translate }} {{ functionsService.convertUTCDateToLocalDate(document.uploaded) }}</small></p>
                                <p class="card-text"><small class="text-muted">{{ 'manage_documents.uploaded_by' | translate }} {{ document.profileFirstName }} {{ document.profileLastName }}</small></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>